var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning 1 (Traced)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5988 0.0669418C13.5281 0.314431 12.6722 0.859687 12.0548 1.6876C11.7344 2.11719 1.17621 21.4665 0.928373 22.0782C0.0873851 24.154 1.07903 26.6333 3.13509 27.5954C3.33427 27.6886 3.70406 27.8178 3.95695 27.8824C4.41055 27.9984 4.56515 28 15.4997 28C26.4342 28 26.5888 27.9984 27.0424 27.8824C28.4384 27.5254 29.5147 26.5948 30.0353 25.2946C30.4698 24.2095 30.4823 23.095 30.0713 22.0782C29.8215 21.4602 19.2654 2.11777 18.9394 1.68074C18.4091 0.969772 17.6501 0.442187 16.7493 0.158428C16.2288 -0.00553798 15.117 -0.0528505 14.5988 0.0669418ZM16.2262 7.27668C16.7326 7.5054 17.0619 7.91755 17.182 8.47304C17.2324 8.70594 17.2458 10.0102 17.2325 13.382L17.2143 17.9737L17.0522 18.304C16.8761 18.6624 16.6232 18.9165 16.2391 19.1206C15.8867 19.3079 15.1127 19.3079 14.7602 19.1206C14.3762 18.9165 14.1233 18.6624 13.9472 18.304L13.785 17.9737L13.7669 13.382C13.7535 10.0102 13.767 8.70594 13.8174 8.47304C14.0553 7.37294 15.1908 6.80902 16.2262 7.27668ZM16.2262 21.2263C17.5531 21.8256 17.5617 23.6717 16.2409 24.3456C15.947 24.4955 15.3856 24.5497 15.0546 24.4602C14.1944 24.2274 13.6299 23.3247 13.8074 22.4657C14.0418 21.3304 15.1733 20.7507 16.2262 21.2263Z",
    fill: "#FF007A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6395a6bef6a3d2d9e158bb956335f8e5.svg";
export { ForwardRef as ReactComponent };